import LocalizedStrings from 'react-localization';
import uk from './uk';


let strings = new LocalizedStrings({
    uk: uk
});
strings.setLanguage('uk');

export default strings;